module.exports = __webpack_public_path__ + "img/logo.7b8a3112.png";